module.exports = {"attributes":{"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.5 12C15.7761 12 14.1228 12.6848 12.9038 13.9038C11.6848 15.1228 11 16.7761 11 18.5C11 21.2494 12.7944 23.258 14.2988 24.7131L21.2929 31.7071C21.6834 32.0976 22.3166 32.0976 22.7071 31.7071L29.7035 24.7107C30.493 23.9369 31.3733 23.0071 32.0254 21.8947C31.6945 21.9637 31.3515 22 31 22C30.5332 22 30.0814 21.936 29.6527 21.8164C29.2551 22.3167 28.7931 22.8026 28.3001 23.2857L22 29.5858L15.7071 23.2929L15.695 23.281C14.2007 21.8365 13 20.3469 13 18.5C13 17.3065 13.4741 16.1619 14.318 15.318C15.1619 14.4741 16.3065 14 17.5 14C18.2798 14 18.8868 14.1098 19.4482 14.3543C20.016 14.6016 20.5999 15.0141 21.2929 15.7071C21.6834 16.0976 22.3166 16.0976 22.7071 15.7071C23.4001 15.0141 23.984 14.6016 24.5518 14.3543C25.1132 14.1098 25.7202 14 26.5 14C26.6613 14 26.8216 14.0087 26.9805 14.0257C27.4771 13.3556 28.1373 12.8141 28.902 12.4601C28.1449 12.159 27.3306 12 26.5 12C25.5198 12 24.6268 12.1402 23.7532 12.5207C23.1403 12.7876 22.5679 13.1594 22 13.6393C21.4321 13.1594 20.8597 12.7876 20.2468 12.5207C19.3732 12.1402 18.4802 12 17.5 12Z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
